import {
    FETCH_HELP_TOPICS_REQUEST,
    FETCH_HELP_TOPICS_SUCCESS,
    FETCH_HELP_TOPICS_FAILURE,
    CREATE_HELP_TOPIC_REQUEST,
    CREATE_HELP_TOPIC_SUCCESS,
    CREATE_HELP_TOPIC_FAILURE,
    UPDATE_HELP_TOPIC_REQUEST,
    UPDATE_HELP_TOPIC_SUCCESS,
    UPDATE_HELP_TOPIC_FAILURE,
    DELETE_HELP_TOPIC_REQUEST,
    DELETE_HELP_TOPIC_SUCCESS,
    DELETE_HELP_TOPIC_FAILURE,
  } from "../actions/types";
  
  const initialState = {
    helpTopics: [],
    loading: false,
    error: null,
    message: "",
  };
  
  const helpTopicReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_HELP_TOPICS_REQUEST:
        return { ...state, loading: true, error: null };
  
      case FETCH_HELP_TOPICS_SUCCESS:
        return {
          ...state,
          loading: false,
          helpTopics: action.payload,
          message: "Help topics loaded successfully",
        };
  
      case FETCH_HELP_TOPICS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          helpTopics: [],
        };
  
      case CREATE_HELP_TOPIC_REQUEST:
        return { ...state, loading: true, error: null };
  
      case CREATE_HELP_TOPIC_SUCCESS:
        return {
          ...state,
          loading: false,
          helpTopics: [...state.helpTopics, action.payload],
          message: "Help topic created successfully",
        };
  
      case CREATE_HELP_TOPIC_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case UPDATE_HELP_TOPIC_REQUEST:
        return { ...state, loading: true, error: null };
  
      case UPDATE_HELP_TOPIC_SUCCESS:
        return {
          ...state,
          loading: false,
          helpTopics: state.helpTopics.map((topic) =>
            topic.help_topic_id === action.payload.topic_id ? action.payload : topic
          ),
          message: "Help topic updated successfully",
        };
  
      case UPDATE_HELP_TOPIC_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case DELETE_HELP_TOPIC_REQUEST:
        return { ...state, loading: true, error: null };
  
      case DELETE_HELP_TOPIC_SUCCESS:
        return {
          ...state,
          loading: false,
          helpTopics: state.helpTopics.filter(
            (topic) => topic.topic_id !== action.payload
          ),
          message: "Help topic deleted successfully",
        };
  
      case DELETE_HELP_TOPIC_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default helpTopicReducer;
  